import React from "react";
import { Box } from "@mui/material";
import Header from "../../component-files/Header";
import InventoryCountsByVendor from "../../component-files/Charts/InventoryCountsByVendor";

const DashboardInventory = () => {
    return (
        <Box m="20px">
            <Header title="INVENTORY DASHBOARD" subtitle="Overview of inventory metrics across schools and districts" />

            {/* Inventory Counts by Vendor Component */}
            <InventoryCountsByVendor />
        </Box>
    );
};

export default DashboardInventory;
